import 'gran-style/dist/gran-style/gran-style.css';

import './App.css';

function App() {
    async function app(){
        await customElements.whenDefined('gs-app');
        const element = document.querySelector('#MY_APP');
        return await element.services();
    }

    const toggleContent = async () => (await app()).bars.toggle();

    const toggleMenu = async () => (await app()).menu.toggle();
    const toggleMode = async () => (await app()).mode.toggle();

    const toggleContext = async () => (await app()).context.toggle();
    const toggleDropdown = async () => (await app()).dropdown.toggle();

    const notifyInfo = async () => (await app()).notify.info('bla bla bla!', {title: 'bla bla bla!'});
    const notifySuccess = async () => (await app()).notify.success('bla bla bla...');
    const notifyWarning = async () => (await app()).notify.warning('bla bla bla...', {title: 'bla bla bla!'});
    const notifyDanger = async () => (await app()).notify.danger('bla bla bla...', {title: 'bla bla bla!'});

    const alertInfo = async () => (await app()).alert.info('bla bla bla...', {title: 'bla bla bla!'});
    const alertSuccess = async () => (await app()).alert.success('bla bla bla...', {title: 'bla bla bla!'});
    const alertWarning = async () => (await app()).alert.warning('bla bla bla...', {title: 'bla bla bla!', confirmation: true});
    const alertDanger = async () => (await app()).alert.danger('bla bla bla...', {title: 'bla bla bla!', confirmation: true});

    const loaderPromise = async (config) => {
        const loader = (await app()).loader;
        await loader.wait(
            new Promise(
                (resolve) => setTimeout(() => resolve(null), 1000 * (1 + loader.count())),
            ),
            config,
        );
    }
    const loaderTitle = () => loaderPromise({header: 'header bla bla bla...!'});
    const loaderMessage = () => loaderPromise({message: 'message bla bla bla...'});
    const loaderImage = () => loaderPromise({image: 'https://cloudfront.grancursosonline.com.br/assets/site/img/logo/logo.svg'});
    const loaderAll = () => loaderPromise({
        header: 'header bla bla bla!',
        message: 'message bla bla bla...',
        image: 'https://cloudfront.grancursosonline.com.br/assets/site/img/logo/logo.svg',
    })
    const loaderMany = () => {
        loaderTitle();
        loaderMessage();
        loaderImage();
        loaderAll();
    }

    return <gs-app id="MY_APP">
        <div slot="header">

            <gs-item>
                <div slot="left">
                    <img className="m12" height="30" alt="" src="https://cloudfront.grancursosonline.com.br/assets/site/img/logo/logo.svg" />
                </div>
                <div slot="content">

                    <gs-button shape="circle" onClick={toggleMenu}>
                    <span className="rtt-90">|||</span>
                </gs-button>
            </div>
            <div slot="right">

                <gs-thumb
                    class="m12h"
                    image="https://scontent.fbsb8-2.fna.fbcdn.net/v/t1.18169-9/18033112_1022863617843654_1166094572516268395_n.jpg?_nc_cat=102&ccb=1-3&_nc_sid=09cbfe&_nc_eui2=AeEnNouPbHgZAyjU-vJZNNpIHTL66bzjLfgdMvrpvOMt-K4N0Ctg6YLW3AV3lqcwarZAsN-W4R5aQQj3LROl7DIe&_nc_ohc=TBVjQAg9VtoAX8pDc3i&tn=jDzmzFnmbPJRbMMm&_nc_ht=scontent.fbsb8-2.fna&oh=60b0bac403dbb4bfd863f5515126c320&oe=612EC395"
                    size="40"
                    onClick={toggleContext}
                ></gs-thumb>

                </div>
            </gs-item>

            <gs-item>
                <div slot="left">
                    <img className="m12" height="30" alt="" src="https://cloudfront.grancursosonline.com.br/assets/site/img/logo/logo.svg"/>
                </div>
                <div slot="content">
                    <gs-button shape="circle" onClick={toggleMenu}>
                        <span className="rtt-90">|||</span>
                    </gs-button>
                </div>
                <div slot="right">

                    <gs-thumb
                        className="m12h"
                        image="https://scontent.fbsb8-2.fna.fbcdn.net/v/t1.18169-9/18033112_1022863617843654_1166094572516268395_n.jpg?_nc_cat=102&ccb=1-3&_nc_sid=09cbfe&_nc_eui2=AeEnNouPbHgZAyjU-vJZNNpIHTL66bzjLfgdMvrpvOMt-K4N0Ctg6YLW3AV3lqcwarZAsN-W4R5aQQj3LROl7DIe&_nc_ohc=TBVjQAg9VtoAX8pDc3i&tn=jDzmzFnmbPJRbMMm&_nc_ht=scontent.fbsb8-2.fna&oh=60b0bac403dbb4bfd863f5515126c320&oe=612EC395"
                        size="40"
                        onClick={toggleContext}
                    ></gs-thumb>

                </div>
            </gs-item>

        </div>
        <div slot="menu">

            <gs-list-header></gs-list-header>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Início</div>
            </gs-list-item>
            <gs-list-item active="true">
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Meus Cursos</div>
                <div slot="right"><span className="tx-15">🔒</span></div>
            </gs-list-item>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Assinatura</div>
                <div slot="right">🔒</div>
            </gs-list-item>

            <gs-list-header>Gerenciador de Estudos</gs-list-header>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Cronograma</div>
            </gs-list-item>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Controle de curso</div>
            </gs-list-item>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Guias da aprovação</div>
                <div slot="right"><span className="tx-15">🔒</span></div>
            </gs-list-item>
            <gs-list-item>
                <div slot="left"><span className="tx-15">🏠</span></div>
                <div slot="content">Monitor de desempenho</div>
            </gs-list-item>

            <gs-list-header>Componentes</gs-list-header>
            <gs-list-item href="#gs-app">
                <div slot="left"><span className="tx-15">🖥️</span></div>
                <div slot="content">gs-app</div>
                <div slot="right">⭐</div>
            </gs-list-item>
            <gs-list-item href="#gs-screen">
                <div slot="left"><span className="tx-15">👀</span></div>
                <div slot="content">gs-screen</div>
            </gs-list-item>
            <gs-list-item href="#gs-item">
                <div slot="left"><span className="tx-15">👆</span></div>
                <div slot="content">gs-item</div>
            </gs-list-item>
            <gs-list-item href="#gs-notify">
                <div slot="left"><span className="tx-15">⏰</span></div>
                <div slot="content">gs-notify</div>
            </gs-list-item>
            <gs-list-item href="#gs-alert">
                <div slot="left"><span className="tx-15">🛎️</span></div>
                <div slot="content">gs-alert</div>
            </gs-list-item>
            <gs-list-item href="#gs-button">
                <div slot="left"><span className="tx-15">🖱️</span></div>
                <div slot="content">gs-button</div>
            </gs-list-item>
            <gs-list-item href="#gs-section">
                <div slot="left"><span className="tx-15">🏁</span></div>
                <div slot="content">gs-section</div>
            </gs-list-item>
            <gs-list-item href="#gs-empty">
                <div slot="left"><span className="tx-15">🧹</span></div>
                <div slot="content">gs-empty</div>
            </gs-list-item>

        </div>
        <div slot="content">

            <fieldset className="my-fieldset" id="my-banner">
                <legend>gran-style</legend>
                <section>

                    <div className="tx-50 tx-bolder"><a className="my-title" target="_blank" rel="noreferrer" href="https://gran-style.web.app/">GRAN STYLE</a></div>
                    <div className="tx-20">
                        <span>Feito com </span>
                        <a target="_blank" rel="noreferrer" href="https://react-gran-style.web.app/"><b className="tx-underline my-react">React</b></a>
                        <span>, mas poderia ser </span>
                        <a target="_blank" rel="noreferrer" href="https://js-gran-style.firebaseapp.com/"><b className="tx-underline my-js">JS</b></a>
                        <span>, </span>
                        <a target="_blank" rel="noreferrer" href="https://angular-gran-style.web.app/"><b className="tx-underline my-angular">Angular</b></a>
                        <span> ou </span>
                        <a target="_blank" rel="noreferrer" href="https://vue-gran-style.web.app/"><b className="tx-underline my-vue">Vue</b></a>!
                    </div>

                    <p>
                        <a target="_blank" rel="noreferrer" href="https://drive.google.com/drive/folders/1Ofh2wxgV-yFPZlf1J3cYyXcpV3X73os-?usp=sharing">ANDROID</a>
                        <span> &bull; </span>
                        <span>iOS</span>
                        <span> &bull; </span>
                        <a target="_blank" rel="noreferrer" href="https://drive.google.com/drive/folders/1Ofh2wxgV-yFPZlf1J3cYyXcpV3X73os-?usp=sharing">WINDOWS</a>
                        <span> &bull; </span>
                        <span>LINUX</span>
                        <span> &bull; </span>
                        <span>MAC</span>
                    </p>

                    <p>
                        <a target="_blank" rel="noreferrer" href="https://gran-style.web.app">docs</a>
                        <span> &bull; </span>
                        <a target="_blank" rel="noreferrer" href="https://bitbucket.org/ggeducacional/gran-style-apps/src">demos</a>
                        <span> &bull; </span>
                        <a target="_blank" rel="noreferrer" href="https://www.npmjs.com/package/gran-style">npm</a>
                        <span> &bull; </span>
                        <a target="_blank" rel="noreferrer" href="https://bitbucket.org/ggeducacional/gran-style/src">git</a>
                    </p>

                </section>
            </fieldset>

            {/*gs-app*/}
            <fieldset className="my-fieldset">
                <legend id="gs-app">gs-app</legend>

                <section>

                    <fieldset>
                        <legend>content</legend>
                        <section>
                            <button type="button" onClick={toggleContent}>expand/contract</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>menu</legend>
                        <section>
                            <button type="button" onClick={toggleMenu}>toggle</button>
                            <button type="button" onClick={toggleMode}>mode</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>context</legend>
                        <section>
                            <button type="button" onClick={toggleContext}>toggle</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>dropdown</legend>
                        <section>
                            <button type="button" onClick={toggleDropdown}>toggle</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>notify</legend>
                        <section>
                            <button type="button" onClick={notifyInfo}>info</button>
                            <button type="button" onClick={notifySuccess}>success</button>
                            <button type="button" onClick={notifyWarning}>warning</button>
                            <button type="button" onClick={notifyDanger}>danger</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>alert</legend>
                        <section>
                            <button type="button" onClick={alertInfo}>info</button>
                            <button type="button" onClick={alertSuccess}>success</button>
                            <button type="button" onClick={alertWarning}>warning</button>
                            <button type="button" onClick={alertDanger}>danger</button>
                        </section>
                    </fieldset>

                    <fieldset>
                        <legend>loader</legend>
                        <section>
                            <button type="button" onClick={loaderTitle}>title</button>
                            <button type="button" onClick={loaderMessage}>message</button>
                            <button type="button" onClick={loaderImage}>image</button>
                            <button type="button" onClick={loaderAll}>all</button>
                            <button type="button" onClick={loaderMany}>many</button>
                        </section>
                    </fieldset>

                </section>
            </fieldset>

            {/*gs-screen*/}
            <fieldset className="my-fieldset">
                <legend id="gs-screen">gs-screen</legend>
                <section>

                    <section className="my-window">
                        <gs-screen class="my-screen-example">
                            <div slot="header" className="p12">
                                HEADER
                            </div>
                            <div slot="left" className="p12">
                                LEFT
                            </div>
                            <div slot="body" className="p12">
                                BODY
                            </div>
                            <div slot="right" className="p12">
                                RIGHT
                            </div>
                            <div slot="footer" className="p12">
                                FOOTER
                            </div>
                        </gs-screen>
                    </section>

                    <br/>

                    <section className="my-window">
                        <gs-screen class="my-screen-example">
                            <div slot="header" className="p12">
                                HEADER
                            </div>
                            <div slot="left" className="p12">
                                LEFT
                            </div>
                            <div slot="body">

                                <gs-screen class="my-screen-example-child">
                                    <div slot="header" className="p12">
                                        HEADER
                                    </div>
                                    <div slot="left" className="p12">
                                        LEFT
                                    </div>
                                    <div slot="body" className="p12">
                                        BODY
                                    </div>
                                    <div slot="right" className="p12">
                                        RIGHT
                                    </div>
                                    <div slot="footer" className="p12">
                                        FOOTE
                                    </div>
                                </gs-screen>

                            </div>
                            <div slot="right" className="p12">
                                RIGHT
                            </div>
                            <div slot="footer" className="p12">
                                FOOTER
                            </div>
                        </gs-screen>
                    </section>

                    <br/>

                    <section className="my-window">
                        <gs-screen class="my-screen-example">
                            <div slot="header" className="p12">
                                HEADER
                            </div>
                            <div slot="body">

                                <gs-screen class="my-screen-example-child">
                                    <div slot="left" className="p12">
                                        LEFT
                                    </div>
                                    <div slot="body" className="p12">
                                        BODY
                                    </div>
                                    <div slot="right" className="p12">
                                        RIGHT
                                    </div>
                                </gs-screen>

                            </div>
                            <div slot="footer" className="p12">
                                FOOTER
                            </div>
                        </gs-screen>
                    </section>

                    <br/>

                    <section className="my-window">
                        <gs-screen class="my-screen-example">
                            <div slot="header" className="p12">
                                HEADER
                            </div>
                            <div slot="body">

                                <gs-screen class="my-screen-example-child">
                                    <div slot="left" className="p12">
                                        LEFT
                                    </div>
                                    <div slot="body" className="p12">
                                        BODY
                                    </div>
                                    <div slot="footer" className="p12">
                                        FOOTE
                                    </div>
                                </gs-screen>

                            </div>
                            <div slot="right" className="p12">
                                RIGHT
                            </div>
                        </gs-screen>
                    </section>

                </section>
            </fieldset>

            {/*gs-item*/}
            <fieldset className="my-fieldset">
                <legend id="gs-item">gs-item</legend>
                <section>

                    <gs-item class="my-item">
                        <div slot="left" className="p12">
                            LEFT
                        </div>
                        <div slot="content" className="p12">
                            CONTENT
                        </div>
                        <div slot="right" className="p12">
                            RIGHT
                        </div>
                    </gs-item>

                    <br/>

                    <gs-item class="my-item">
                        <div slot="left" className="p12">
                            LEFT
                        </div>
                        <div slot="content" className="p12">
                            CONTENT
                        </div>
                    </gs-item>

                    <br/>

                    <gs-item class="my-item">
                        <div slot="content" className="p12">
                            CONTENT
                        </div>
                        <div slot="right" className="p12">
                            RIGHT
                        </div>
                    </gs-item>

                    <br/>

                    <gs-item class="my-item">
                        <div slot="content" className="p12">
                            CONTENT
                        </div>
                    </gs-item>

                </section>
            </fieldset>

            {/*gs-notify*/}
            <fieldset className="my-fieldset">
                <legend id="gs-notify">gs-notify</legend>
                <section>
                    <gs-notify type="primary">
                        <div className="tx-bolder">Título da mensagem!</div>
                        <div>Um monte de bla bla bla da mensagem...</div>
                    </gs-notify>
                    <gs-notify type="secondary">Uma mensagem direta em nada de mais...</gs-notify>
                    <gs-notify type="success">Uma linda mensagem de <b>sucesso!</b></gs-notify>
                    <gs-notify type="info">Apenas uma mensagem informativa...</gs-notify>
                    <gs-notify type="warning">Ops! Uma mensagem de alerta!</gs-notify>
                    <gs-notify type="danger">
                        <div className="tx-bolder">Deu ruim :(</div>
                        <div>Mensagem de erro ou falha... faz certo que dá certo porra!</div>
                    </gs-notify>
                </section>
            </fieldset>

            {/*gs-alert*/}
            <fieldset className="my-fieldset my-overlay">
                <legend id="gs-alert">gs-alert</legend>
                <section>

                    <div className="my-popup">
                        <gs-alert type="primary">
                            <div slot="title">
                                <div className="tx-bolder">Título da mensagem!</div>
                            </div>
                            <div slot="message">
                                <div>Um monte de bla bla bla da mensagem...</div>
                            </div>
                        </gs-alert>
                    </div>

                    <div className="my-popup">
                        <gs-alert type="warning" confirmation="true">
                            <div slot="title">
                                <div className="tx-bolder">Título da mensagem!</div>
                            </div>
                            <div slot="message">
                                <div>Um monte de bla bla bla da mensagem...</div>
                            </div>
                        </gs-alert>
                    </div>

                    <div className="my-popup">
                        <gs-alert type="danger">
                            <div slot="title">
                                <div className="tx-bolder">Título da mensagem!</div>
                            </div>
                            <div slot="message">
                                <div>Um monte de bla bla bla da mensagem...</div>
                            </div>
                        </gs-alert>
                    </div>

                </section>
            </fieldset>

            {/*gs-button*/}
            <fieldset className="my-fieldset">
                <legend id="gs-button">gs-button</legend>
                <section>

                    <p>disable = true - false</p>

                    <gs-button color="primary">Ativo</gs-button>

                    <gs-button color="primary" disable="true">Inativo</gs-button>

                    <p>color = primary - secondary - info - success - warning - danger</p>

                    <gs-button color="primary">Primário</gs-button>

                    <gs-button color="secondary">Secundário</gs-button>

                    <gs-button color="info">Aviso!</gs-button>

                    <gs-button color="success">Sucesso!</gs-button>

                    <gs-button color="warning">Atenção!</gs-button>

                    <gs-button color="danger">Cancelar</gs-button>

                    <gs-button>Padrão</gs-button>

                    <p>size = xxl - xl - l - m - s - xs - xxs</p>

                    <gs-button color="primary" size="xxl">Gran Grande</gs-button>
                    <gs-button color="secondary" size="xl">Muito Grande</gs-button>
                    <gs-button color="info" size="l">Grande</gs-button>
                    <gs-button color="success" size="m">Médio</gs-button>
                    <gs-button color="warning" size="s">Pequeno</gs-button>
                    <gs-button color="danger" size="xs">Muito Pequeno</gs-button>
                    <gs-button size="xxs">Micro</gs-button>

                    <p>shape =  edge | rounded |circle | square</p>

                    <gs-button shape="rounded" color="primary" size="xxl">rounded</gs-button>
                    <gs-button shape="rounded" color="secondary" size="xl">rounded</gs-button>
                    <gs-button shape="rounded" color="info" size="l">rounded</gs-button>
                    <gs-button shape="rounded" color="success" size="m">rounded</gs-button>
                    <gs-button shape="rounded" color="warning" size="s">rounded</gs-button>
                    <gs-button shape="rounded" color="danger" size="xs">rounded</gs-button>
                    <gs-button shape="rounded" size="xxs">rounded</gs-button>

                    <p></p>

                    <gs-button shape="square" color="primary" size="xxl">square</gs-button>
                    <gs-button shape="square" color="secondary" size="xl">square</gs-button>
                    <gs-button shape="square" color="info" size="l">square</gs-button>
                    <gs-button shape="square" color="success" size="m">square</gs-button>
                    <gs-button shape="square" color="warning" size="s">square</gs-button>
                    <gs-button shape="square" color="danger" size="xs">square</gs-button>
                    <gs-button shape="square" size="xxs">square</gs-button>

                    <p></p>

                    <gs-button shape="circle" color="primary" size="xxl">🐻</gs-button>
                    <gs-button shape="circle" color="secondary" size="xl">🔥</gs-button>
                    <gs-button shape="circle" color="info" size="l">🤏</gs-button>
                    <gs-button shape="circle" color="success" size="m">🍔</gs-button>
                    <gs-button shape="circle" color="warning" size="s">❤️</gs-button>
                    <gs-button shape="circle" color="danger" size="xs">⚽</gs-button>
                    <gs-button shape="circle" size="xxs">i</gs-button>

                </section>
            </fieldset>

            {/*gs-section*/}
            <fieldset className="my-fieldset">
                <legend id="gs-section">gs-section</legend>
                <section>

                    <section className="my-section">
                        <gs-section>
                            <div slot="title">Título da seção!</div>
                            <div slot="subtitle">Subtítulo de uma determinada seção.</div>
                            <div slot="hint">Uma breve descrição ou informação sobre esta seção...</div>
                            <div slot="content">Contaúdo da sesão</div>
                        </gs-section>
                    </section>

                    <br/>

                    <section className="my-section">
                        <gs-section>
                            <div className="my-grey-1" slot="title">Título da seção!</div>
                            <div className="my-grey-2" slot="subtitle">Subtítulo de uma determinada seção.</div>
                            <div className="my-grey-3" slot="hint">Uma breve descrição ou informação sobre esta
                                seção...
                            </div>
                            <div className="my-grey-4" slot="content">Contaúdo da sesão</div>
                        </gs-section>
                    </section>

                    <br/>

                    <section className="my-section">
                        <gs-section>
                            <div slot="title">Título da seção!</div>
                            <div slot="subtitle">Subtítulo de uma determinada seção.</div>
                            <div slot="content">
                                <table border="1" width="100%">
                                    <thead>
                                    <tr>
                                        <th>col 1</th>
                                        <th>col 2</th>
                                        <th>col 3</th>
                                        <th>col 4</th>
                                        <th>col 5</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>value 1</td>
                                        <td>value 2</td>
                                        <td>value 3</td>
                                        <td>value 4</td>
                                        <td>value 5</td>
                                    </tr>
                                    <tr>
                                        <td>value 1</td>
                                        <td>value 2</td>
                                        <td>value 3</td>
                                        <td>value 4</td>
                                        <td>value 5</td>
                                    </tr>
                                    <tr>
                                        <td>value 1</td>
                                        <td>value 2</td>
                                        <td>value 3</td>
                                        <td>value 4</td>
                                        <td>value 5</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </gs-section>
                    </section>

                    <br/>

                    <section className="my-section">
                        <gs-section>
                            <div slot="title">Título da seção!</div>
                            <div slot="hint">Uma breve descrição ou informação sobre esta seção...</div>
                            <div slot="content">
                                <img width="100%" alt="" src="https://www.industrialempathy.com/img/remote/ZiClJf-1920w.jpg" />
                            </div>
                        </gs-section>
                    </section>

                </section>
            </fieldset>

            {/*gs-empty*/}
            <fieldset className="my-fieldset">
                <legend id="gs-empty">gs-empty</legend>
                <section>

                    <section className="my-section">
                        <gs-empty image="https://www.grancursosonline.com.br/assets/site/img/home/ilustracao-home.svg">
                            <div slot="title">Arquivo não encontrado.</div>
                            <div slot="subtitle">O arquivo selecionado não existe ou talvez você não possa acessá-lo.
                            </div>
                        </gs-empty>
                    </section>

                </section>
            </fieldset>

        </div>
        <div slot="context" id="my-context">

            <gs-screen class="my-screen-example">
                <div slot="header" className="p12">
                    HEADER
                </div>
                <div slot="left" className="p12">
                    LEFT
                </div>
                <div slot="body" className="p12 tx-center">

                    <gs-thumb
                        image="https://lh3.googleusercontent.com/ogw/ADea4I7FNqe8J28FRc40cUOUR5gSxGM8gSznBqV4WMxL=s83-c-mo"
                        size="100"
                    ></gs-thumb>

                    <button type="button" onClick={toggleMenu}>toggle menu</button>
                    <button type="button" onClick={toggleDropdown}>toggle dropdown</button>

                </div>
                <div slot="right" className="p12">
                    RIGHT
                </div>
                <div slot="footer" className="p12">
                    FOOTER
                </div>
            </gs-screen>

        </div>
        <div slot="dropdown">

            <section id="my-dropdown">
                <gs-screen class="my-screen-example">
                    <div slot="header" className="p12">
                        HEADER
                    </div>
                    <div slot="left" className="p12">
                        LEFT
                    </div>
                    <div slot="body" className="p12 tx-center">

                        <gs-thumb
                            image="https://lh3.googleusercontent.com/ogw/ADea4I7FNqe8J28FRc40cUOUR5gSxGM8gSznBqV4WMxL=s83-c-mo"
                            size="100"
                        ></gs-thumb>

                        <button type="button" onClick={toggleMenu}>toggle menu</button>
                        <button type="button" onClick={toggleDropdown}>toggle dropdown</button>

                    </div>
                    <div slot="right" className="p12">
                        RIGHT
                    </div>
                    <div slot="footer" className="p12">
                        FOOTER
                    </div>
                </gs-screen>
            </section>

        </div>
    </gs-app>;
}

export default App;
